'use client';

import { Plus } from 'lucide-react';

const WEEKDAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

const CALENDAR_EVENTS = [
  {
    id: 'e1',
    time: '9:00 AM',
    title: 'Kin Daily Check-In Call',
    subtitle: 'Automated',
    dotColor: '#10B981',
    pillBg: 'rgba(16, 185, 129, 0.12)',
  },
  {
    id: 'e2',
    time: '11:30 AM',
    title: 'Dr. Chen Appointment',
    subtitle: 'In-person',
    dotColor: '#3B82F6',
    pillBg: 'rgba(59, 130, 246, 0.12)',
  },
  {
    id: 'e3',
    time: '2:00 PM',
    title: 'Metformin Refill Pickup',
    subtitle: 'Task',
    dotColor: '#F97316',
    pillBg: 'rgba(249, 115, 22, 0.12)',
  },
  {
    id: 'e4',
    time: '4:00 PM',
    title: 'Family Check-In Call',
    subtitle: 'Family',
    dotColor: '#8B5CF6',
    pillBg: 'rgba(139, 92, 246, 0.12)',
  },
];

export default function TodaysScheduleCalendar() {
  const todayIndex = (new Date().getDay() + 6) % 7;

  return (
    <div className="glass overflow-hidden">
      <div className="flex items-center justify-between px-4 py-3 border-b border-[#E0DBD3] bg-[#F5F1EB]/50">
        <div className="flex items-center gap-0.5 sm:gap-1">
          {WEEKDAYS.map((day, i) => (
            <span
              key={day}
              className={`min-w-[28px] sm:min-w-[36px] h-8 px-1 sm:px-2 flex items-center justify-center rounded-full text-[10px] sm:text-xs font-medium transition-colors ${
                i === todayIndex
                  ? 'bg-[#D6AB47] text-[#000000]'
                  : 'text-[#9B9590] hover:text-[#312F2F]'
              }`}
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              {day}
            </span>
          ))}
        </div>
        <button
          type="button"
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium text-[#312F2F] hover:bg-[#E8E4DC] transition-colors"
          style={{ fontFamily: 'Inter, sans-serif' }}
        >
          <Plus size={18} strokeWidth={2.5} />
          Add Event
        </button>
      </div>

      <div className="p-4 space-y-1 min-h-[200px]">
        {CALENDAR_EVENTS.map((event) => (
          <div key={event.id} className="flex gap-3 items-stretch">
            <span
              className="flex-shrink-0 w-14 text-xs text-[#9B9590] pt-1.5"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              {event.time}
            </span>
            <div className="flex-1 min-w-0">
              <div
                className="rounded-lg border border-transparent pl-3 pr-3 py-2.5"
                style={{ backgroundColor: event.pillBg }}
              >
                <div className="flex items-center gap-2">
                  <span
                    className="w-2 h-2 rounded-full flex-shrink-0"
                    style={{ backgroundColor: event.dotColor }}
                  />
                  <div className="min-w-0 flex-1">
                    <p
                      className="text-sm font-semibold text-[#312F2F] truncate"
                      style={{ fontFamily: 'Inter, sans-serif' }}
                    >
                      {event.title}
                    </p>
                    <p
                      className="text-xs text-[#9B9590]"
                      style={{ fontFamily: 'Inter, sans-serif' }}
                    >
                      {event.subtitle}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
